import React, {useEffect} from 'react';
import {t} from 'i18next';
import {PageIndicator} from '../../PageIndicator/PageIndicator';
import {ItemsHeaderWrapper, LayoutButton} from './ItemsHeader.style';
import {LayoutViewType} from '../../../models/LayoutViewType';
import {useIsMobile} from '../../../hooks/UseIsMobile';
import {generateIdentifier} from '../../../utils/IdentityUtils';

export interface ItemsHeaderProps {
    readonly page: number;
    readonly pageCount: number;
    readonly itemsCount: number;
    readonly itemsPerPageCount: number;
    readonly totalItemsCount: number;
    readonly itemLayout: string;
    onPageChange: (newPage: number) => void;
    onLayoutChange: (newLayout: LayoutViewType) => void;
}

/**
 * @name ItemsHeader
 * @description
 * Component for the footer of the item visualisation
 */
export const ItemsHeader: React.VFC<ItemsHeaderProps> = (props) => {
    const isMobile = useIsMobile();

    const setMobileViewMode = () => {
        props.onLayoutChange(LayoutViewType.GRID);
    };

    useEffect(() => {
        if (isMobile) {
            setMobileViewMode();
        }
    }, [isMobile]);

    return (
        <ItemsHeaderWrapper id={generateIdentifier()}>
            <div id={generateIdentifier()}>
                {' '}
                {t('DOWNLOAD_CENTER_RESULT_INFO_TEXT', {
                    pageItemsStartNumber: (props.page - 1) * props.itemsPerPageCount + Math.min(1, props.itemsCount),
                    pageItemsCount: (props.page - 1) * props.itemsPerPageCount + Math.min(props.itemsPerPageCount, props.itemsCount),
                    totalItemsCount: props.totalItemsCount
                })}{' '}
            </div>
            <PageIndicator pages={props.pageCount}
                           selected={props.page}
                           onPageSelect={props.onPageChange}/>
            <div id={generateIdentifier()}>
                <LayoutButton id={generateIdentifier(LayoutViewType.GRID)}
                              className={`${LayoutViewType.GRID}-view`}
                              icon='grid-view'
                              mode='integrated'
                              selected={props.itemLayout === LayoutViewType.GRID}
                              aria-label={t('DATA_HEADER_GRID_VIEW_LABEL')}
                              title={t('DATA_HEADER_GRID_VIEW_LABEL')}
                              onClick={() => props.onLayoutChange(LayoutViewType.GRID)}/>
                <LayoutButton id={generateIdentifier(LayoutViewType.LIST)}
                              className={`${LayoutViewType.LIST}-view`}
                              icon='list-view'
                              mode='integrated'
                              selected={props.itemLayout === LayoutViewType.LIST}
                              title={t('DATA_HEADER_LIST_VIEW_LABEL')}
                              onClick={() => props.onLayoutChange(LayoutViewType.LIST)}/>
                <LayoutButton id={generateIdentifier(LayoutViewType.TABLE)}
                              className={`${LayoutViewType.TABLE}-view`}
                              icon='table'
                              mode='integrated'
                              selected={props.itemLayout === LayoutViewType.TABLE}
                              title={t('DATA_HEADER_TABLE_VIEW_LABEL')}
                              onClick={() => props.onLayoutChange(LayoutViewType.TABLE)}/>
            </div>
        </ItemsHeaderWrapper>
    );
};
